import { setConnectionStatus } from '../../connectionActions';
import routerHistory from '../../../routerHistory';
import { ROUTES } from '../../../const';
import * as _ from 'lodash';
import { getUrlToLogoutCallbackInStorage } from '../../../shared';
import { sendExpiredToken } from '../../../electron/ipcNotifications';

/**
 * After logout operations
 */
export let afterLogout = () => {
  return dispatch => {
    let urlToLogout = getUrlToLogoutCallbackInStorage();
    dispatch(
      setConnectionStatus({
        network: true,
        backend: true,
        rabbit: true,
        general: true,
        online: true
      })
    );
    if (_.isEmpty(urlToLogout) || urlToLogout === 'undefined') {
      routerHistory.push(ROUTES.LOGIN);
    } else if (_.eq(urlToLogout, 'close')) {
      window.close();
    }
  };
};

export const sendExpiredTokenNotification = expired => {
  sendExpiredToken(expired);
};
